module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list",
    attrs: {
      "customInfoId": _vm.listmsg.customInfoId
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.listmsg.infoContentFullUrl
    }
  }, [_c('div', {
    staticClass: "list_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.listmsg.coverImage || require('../../static/images/share_1.png')
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.listmsg.infoTitle || '比笔'))])]), _vm._v(" "), _c('div', {
    staticClass: "list_names clearfloat"
  }, [_c('span', {
    staticClass: "names"
  }, [_vm._v(_vm._s(_vm.listmsg.inputDate || '比笔'))]), _vm._v(" "), _c('div', {
    staticClass: "watch_num"
  }, [_c('div', {
    staticClass: "clearfloat"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": ".84rem"
    }
  }, [(_vm.center) ? _c('span', {
    staticClass: " center"
  }, [_vm._v(_vm._s(_vm.listmsg.voteNumShow || '0'))]) : _vm._e(), _vm._v(" "), (_vm.vote) ? _c('span', {
    staticClass: " center",
    staticStyle: {
      "font-size": ".24rem"
    },
    on: {
      "click": _vm.voteclick
    }
  }, [_vm._v(_vm._s(_vm.listmsg.voteNumShow || '0'))]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.listmsg.hits || '0'))]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "up"
  }, [_c('img', {
    staticClass: "up_img",
    attrs: {
      "src": require("../../static/images/star.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "watch"
  }, [_c('img', {
    staticClass: "watch_img",
    attrs: {
      "src": require("../../static/images/icon-read-btn.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad46dc58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 72
// module chunks = 1